module.exports = __webpack_public_path__ + "img/hk_oshiho.a1d66426.png";